

































import { Component, Vue } from 'vue-property-decorator'
import BlkTriangle from '~/components/BlkTriangle.vue'
import BlkWhyBalkoCarousel from '~/components/learn-more/BlkWhyBalkoCarousel.vue'

interface TriangleType {
  fillColor: string
  strokeColor: string
  size: number
  sizeMobile: number
}

@Component({
  name: 'BlkWhyBalko',
  layout: 'default',
  components: {
    BlkTriangle,
    BlkWhyBalkoCarousel
  }
})
export default class extends Vue {
  currentSlideIndex = 0

  triangles: TriangleType[] = [
    {
      fillColor: 'transparent',
      strokeColor: '#71F69C',
      size: 240,
      sizeMobile: 88
    },
    {
      fillColor: '#71F69C',
      strokeColor: 'transparent',
      size: 94,
      sizeMobile: 60
    },
    {
      fillColor: 'transparent',
      strokeColor: '#71F69C',
      size: 251,
      sizeMobile: 92
    }
  ]
}
